import React from "react";
import UpdateCardForm from "../UpdateCardForm";
import FakeStripePaymentElement from "./StripePaymentElement";

export default function (props) {
  return (
    <UpdateCardForm
      {...props}
      StripePaymentElement={FakeStripePaymentElement}
    />
  );
}
